<template>
  <div>
    <div class="page-header">
      <h1>Services</h1>
    </div>
    <section class="page-content">
      <p>This is a comprehensive list of services we offer</p>
      <div class="service-cards">
        <div v-for="s in services" :key="s.id" class="card">
          <h3>{{ s.name }}</h3>
          <p>{{ s.short_des }}</p>
          <a
            class="btn btn-outline-dark"
            href=""
            @click.prevent="_navigate(s.link)"
            >Learn more</a
          >
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
/* card grid  */
div.service-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;
}
/* card styles */
.page-content .card {
  grid-column: span 1;
  border-radius: 1rem;
  box-shadow: 2px 8px 30px lightgrey;
  padding: 1rem;
}
.card > a {
  text-decoration: none;
}
/* media queries */
@media only screen and (max-width: 998px) {
  .page-content .card {
    grid-column: span 3;
  }
}
</style>

<script>
export default {
  data() {
    return {
      services: [
        {
          name: "Venture Management",
          short_des:
            "Commit your venture to capable hands and certified managers.",
          link: "venture-management"
        },
        {
          name: "Training",
          short_des: "Training programmes oragnized and facilitated by CSVC",
          link: "training"
        },
        {
          name: "Research & Business Development",
          short_des: "Research based analysis for reliable business insights",
          link: "research-development"
        },
        {
          name: "Trademarked SME Events",
          short_des:
            "Events targeted at SMEs to enlighten and expose them to great opportunites and access",
          link: "sme-events"
        },
        {
          name: "SME Business Funding",
          short_des: "Get proper consultation and access funding for your SME.",
          link: "sme-funding"
        }
      ]
    };
  },
  methods: {
    _navigate: function(link) {
      return this.$router.push({ name: link });
    }
  }
};
</script>
